import * as constActions from './auditConstActions';
import initialState from './initialState';

export default function auditPageReducer(state = initialState, action) {
  switch (action.type) {
    case constActions.INIT_AUDIT_DATA: {
      return Object.assign({}, state, {
        results: action.data
      });
    }
    case constActions.GET_AUDIT_COLUMNS: {
      return Object.assign({}, state, {
        columns: action.data
      });
    }
    case constActions.GET_AUDIT_HEADER_TO_DISPLAY: {
      return Object.assign({}, state, {
        headerColumns: action.data
      });
    }
    case constActions.FETCH_RESULTS: {
      return Object.assign({}, state, {
        results: action.data
      });
    }
    case constActions.FETCH_EXISTING_RESULTS: {
      return Object.assign({}, state, {
        results: [...state.results, ...action.data]
      });
    }
    //Global actions
    case constActions.SET_SITES_PER_USER:
      return Object.assign({}, state, {
        sitesPerUser: action.data
      });
    case constActions.SITES_BY_LOGGED_IN_USER:
      return Object.assign({}, state, {
        siteByLoggedInUser: action.data
      });
    default:
      return state;
  }
}
